/**
 * Creates a query key tuple used by react-query.
 * Useful for scoping cache data.
 */
export default function createQueryKey<T extends Record<string, unknown>>(
  params: T & { key: string },
): [string, Omit<T, 'key'>] {
  const { key, ...rest } = params;
  return [key, rest];
}
